import React, {useState, useEffect} from "react";
import {Card, CardBody, Container, Row} from "reactstrap";
import {Button, DatePicker, Table} from "antd";
import ApiService from "../util/ApiService";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import Swal from "sweetalert2";
import {Form} from "react-bootstrap";
import HospitalSearch from "../hospital/HospitalSearch";
import UsersSearch from "../dashboard/calender/UsersSearch";


const ManagersRegisterModal = ({show, onHide, onSaveSuccess, hospital = null, user = null}) => {
    const [departmentsFilter, setDepartmentsFilter] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        user_id: '',
        hospital_id: '',
        department_id: ''
    });


    useEffect(() => {
        if (show) {
            setFormData(prevData => ({
                ...prevData,
                user_id: user?.id ?? null,
                hospital_id: hospital?.id ?? null,
            }));

            fetchDepartmentsFilter();
        }
    }, [show]);


    const fetchDepartmentsFilter = async () => {
        try {

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/list-department`,
                {all: true, status: 'S'},
                true
            );

            if (response.code === 200) {

                const {data} = ApiService.handleApiResponse(response);

                setDepartmentsFilter(
                    Array.isArray(data) ? data : []
                );
            } else {
                Swal.fire("Erro", "Erro ao carregar os departamentos.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setDepartments([]);
        }
    };



    const handleSave = async () => {
        try {
            setLoading(true);
            const response = await ApiService.send(
                'post',
                `${process.env.REACT_APP_URL_API}managers/register-user`,
                formData,
                true
            );

            // Verifica se a resposta foi bem-sucedida com base no status HTTP
            if (response?.code === 200) {
                Swal.fire('Sucesso', 'Regra do gestor salvo com sucesso!', 'success').then(() => {
                    onHide(true);
                });
            } else {
                throw new Error(response?.data?.message || 'Erro ao salvar.');
            }
        } catch (error) {
            // Chama o método de tratamento de erro
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };



    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Registrar Regra</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row">
                        <div className="col-12">
                            <UsersSearch
                                initialUser={user}
                                onUserSelect={(user) =>
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        user_id: user?.value || "",
                                    }))
                                }/>
                        </div>
                        <div className="col-md-12">
                            <HospitalSearch
                                buttonAdd={false}
                                initialHospital={hospital}
                                onHospitalSelect={(hospital) =>
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        hospital_id: hospital?.value || "",
                                    }))
                                }
                            />
                        </div>
                        <div className="col-md-12 form-group">
                            <label>Departamentos</label>
                            <Select
                                isClearable
                                options={departmentsFilter.map((dept) => ({
                                    value: dept.id,
                                    label: dept.name,
                                }))}
                                onChange={(dept) =>
                                    setFormData((prevFilters) => ({
                                        ...prevFilters,
                                        department_id: dept?.value || "",
                                    }))}

                                classNamePrefix="select"
                                placeholder="Selecionar Departamento..." // Define o texto interno
                                menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999
                                    }), // Definindo z-index alto
                                    menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                }}
                            />

                        </div>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-dark"  onClick={() =>onHide()}>
                    <i className="fa fa-close"></i> Cancelar
                </button>
                <button type="button" className="btn btn-info"
                        onClick={() =>handleSave()}
                        disabled={loading}>
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Salvando...
                        </>
                    ) : (
                        <>
                            <i className="fa fa-plus me-2"></i> Cadastrar
                        </>
                    )}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ManagersRegisterModal;
